import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WindowRef } from '../../shared/services/window.service';
import { MaintenanceResourceService } from '../../shared/services/maintenance-resource.service';
import { ChartsModule } from 'ng2-charts';
import { TranslateModule } from '@ngx-translate/core';
import { UnitpriceService } from './services/unitprice.service';
import { ChartConfigService } from './services/chartconfig.service';
import { UnitpriceRoutingModule } from './unitprice-routing.module';
import { UnitpriceComponent } from './components/unitprice.component';
import { MyDatePickerModule } from 'mydatepicker';
import { MaintenanceApi } from '../../shared/services/api/maintenance.api';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MyDatePickerModule,
    ReactiveFormsModule,
    UnitpriceRoutingModule,
    ChartsModule,
    TranslateModule.forChild()
  ],
  declarations: [UnitpriceComponent],
  exports: [FormsModule, ReactiveFormsModule],
  providers: [UnitpriceService, ChartConfigService, WindowRef, MaintenanceResourceService, MaintenanceApi]
})
export class UnitpriceModule {
}
